import { biToast } from '@pulsepointinc/bi-components';
import { queryClient } from '../lib';
import type { GetTaskStatusResponse } from '../lib/api/tasks/dto';
import { API_TAGS } from '../lib/constants';
import { type DTCAudienceTask, useDTCAudienceTasksStore } from '../stores/dtcAudienceTasks';
import { useTaskPolling } from './useTaskPolling';

const handleDTCTaskCompletion = async (
  data: GetTaskStatusResponse,
  task: DTCAudienceTask,
  removeTask: (id: string) => void,
) => {
  if ('error' in data) {
    removeTask(task.taskId);
    biToast.error(data.errorDesc || data.error || 'Task failed');
    return;
  }

  const { status } = data.taskDetails;
  if (status === 'completed' || status === 'failed') {
    removeTask(task.taskId);
    await queryClient.invalidateQueries({ queryKey: [API_TAGS.SingleWorkspace] });
    if (status === 'failed') {
      biToast.error(
        task.type === 'publish'
          ? 'Audience publish failed. Please try again.'
          : 'Audience creation failed. Please try again.',
      );
    }
  }
};

export const useDTCAudienceTaskPolling = () => {
  const activeTasks = useDTCAudienceTasksStore((state) => state.activeTasks);
  const removeTask = useDTCAudienceTasksStore((state) => state.removeTask);

  useTaskPolling({
    activeTasks,
    removeTask,
    queryKeyPrefix: 'dtcAudienceTaskStatus',
    timeoutMessage: 'Audience task timed out. Please try again.',
    onComplete: handleDTCTaskCompletion,
  });
};
